import { Icon } from '../common';

// A panel's empty state — an icon, a line naming what would live here, and
// where it helps, a first action (daily-command-strip AC22). Never a blank
// rectangle and never a placeholder string: "No items yet" is not an empty
// state, it is the absence of one.
export interface PanelEmptyProps {
  icon: string;
  line: string;
  detail: string;
  action?: { label: string; onClick: () => void };
}

export function PanelEmpty({ icon, line, detail, action }: PanelEmptyProps) {
  return (
    <div className="cs-empty">
      <span className="cs-empty-ico" aria-hidden="true">
        <Icon name={icon} size={20} />
      </span>
      <span className="cs-empty-line">{line}</span>
      <span className="cs-empty-detail">{detail}</span>
      {action && (
        <button type="button" className="cs-empty-cta" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
}
